import React from "react";
import "./inputField.css";
const InputField = ({
  placeholder,
  label,
  className,
  onPress,
  value,
  onChange,
  errorMsg,
  timer,
  otpSent,
  request,
  resend,
  loader,
}) => {
  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <div
      className={className ? `${className} input_container` : "input_container"}
    >
      <input
        type="text"
        placeholder={placeholder}
        onChange={handleChange}
        value={value}
      />
      {label && (
        <div className="input_label boldFont">
          {otpSent && timer !== "00:00" && !request ? (
            <span
              style={{ pointerEvents: otpSent || (loader && "none") }}
            >{`Resend in ${timer}s`}</span>
          ) : (
            <div
              style={{
                opacity: request && otpSent ? 0.5 : (resend || loader) && 0.5,
                pointerEvents:
                  request && otpSent ? "none" : (resend || loader) && "none",
                cursor: "pointer",
              }}
              onClick={() => onPress()}
            >
              {label}
            </div>
          )}
        </div>
      )}
      {errorMsg && <div className="Input_error_msg boldFont">{errorMsg}</div>}
    </div>
  );
};

export default InputField;
